export const hobbyData = [
  {
    id: 1,
    name: 'Guitar',
    icon: 'musician',
    description:
      'I have been playing the guitar for the past ten years and been to some bands before. Mostly I play Instrumental music.',
    picture: 'phuc-guitar.jpg',
  },
  {
    id: 2,
    name: 'Badminton',
    icon: 'sports',
    description:
      'I started to play badminton since I was six years old and now I am a competitive badminton player here in Finland.',
    picture: 'phuc-badminton.jpg',
  },
  {
    id: 3,
    name: 'Pet My Cats & Dog',
    icon: 'animal',
    description:
      'I am rasing two cats and one dog. They are so cute and friendly so that love to play with them.',
    picture: 'phuc-cat.jpg',
  },
  {
    id: 4,
    name: 'Food',
    icon: 'food',
    description:
      'I love to eat and also eat a lot. Therefore, I created one Instagram account that keeps all of my favorite dishes and who knows maybe one day I will become a food bloger',
    picture: 'phuc-food.png',
  },
  {
    id: 5,
    name: 'Reading News',
    icon: 'news',
    description:
      'I am addicted to new technologies so I read the news everyday to find what can change the our life in the future',
  },
];
